export default __webpack_public_path__ + "locales/si/Settings.json?hash=236dd2c084c48b01f59fb28deb19ba97";